// Player health record validation -- iteration 145
import { z } from "zod";

// All fields optional on upsert (PUT is a full-record replace; absent fields
// clear to null / false). Strings capped; phone left permissive (intl formats).
export const upsertPlayerHealthSchema = z.object({
  medical_conditions: z.string().max(2000).nullable().optional(),
  allergies: z.string().max(2000).nullable().optional(),
  has_medical_aid: z.boolean().optional(),
  medical_aid_name: z.string().max(255).nullable().optional(),
  medical_aid_number: z.string().max(100).nullable().optional(),
  emergency_contact_name: z.string().max(255).nullable().optional(),
  emergency_contact_phone: z.string().max(50).nullable().optional(),
});

export type UpsertPlayerHealthInput = z.infer<typeof upsertPlayerHealthSchema>;
